import { useState } from 'react';

import type { SaveListItem } from '../../../../types/save-types.js';
import type { IEngagementUIElement } from '@schibsted/pulse-sdk';
import type { ByfunnPulseContextInputParams } from '../../../../pulse/index.js';

import { useByfunnPulseContext } from '../../../../pulse/index.js';

export function useTeaserSaveOverlay(
  listTeaser: SaveListItem,
  trackObject: ByfunnPulseContextInputParams<IEngagementUIElement>['object'],
) {
  const [overlay, toggleOverlay] = useState({
    overlayVisible: false,
    itemToSave: listTeaser,
  });

  const { trackClickUIElement } = useByfunnPulseContext();

  const handleOverlay = () => {
    trackClickUIElement(
      {
        object: {
          id: trackObject.objectId,
          name: trackObject.name,
          elementType: trackObject.elementType,
        },
      },
      {
        object: {
          ...trackObject,
        },
        placement: { containerName: 'page' },
      },
    );

    toggleOverlay({
      overlayVisible: !overlay.overlayVisible,
      itemToSave: listTeaser,
    });
  };

  const handleSave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    handleOverlay();
  };

  return {
    overlay,
    toggleOverlay,
    handleSave,
    handleOverlay,
  };
}
